export enum SponsorBannerStatus {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
}

const translationObject: { [Key in SponsorBannerStatus]: string } = {
    [SponsorBannerStatus.Active]: 'app.sponsorBanner.status.active',
    [SponsorBannerStatus.Inactive]: 'app.sponsorBanner.status.inactive',
};

export const getSponsorBannerTranslationId = (status: SponsorBannerStatus): string => {
    return translationObject[status];
};
